import throttle from 'lodash/throttle';
require('dom-slider');

const { slideUp, slideDown } = window.domSlider;

const footerAccordionLinks = document.querySelectorAll(
	'.block-footer-links > .wp-block-button .wp-block-button__link'
);
const footerAccordionContents = document.querySelectorAll(
	'.block-footer-links > .block-content'
);

let previousWidth;

if (footerAccordionLinks.length > 0 && footerAccordionContents.length > 0) {
	footerAccordionLinks.forEach((link) => {
		const block = link.closest('.block-footer-links');
		const allLinks = block.querySelectorAll(
			'.block-content .wp-block-button__link'
		);
		link.setAttribute('role', 'button');
		link.setAttribute('aria-expanded', 'false');
		link.addEventListener('click', (e) => {
			const buttons = e.currentTarget.parentElement.nextElementSibling;

			if (!buttons) {
				return;
			}

			e.preventDefault();

			if (buttons.classList.contains('DOM-slider-hidden')) {
				e.currentTarget.setAttribute('aria-expanded', 'true');

				slideDown({
					element: buttons,
					slideSpeed: 400,
					easing: 'ease-in-out',
				});

				allLinks.forEach((otherLink) => {
					otherLink.setAttribute('tabindex', '0');
				});
			} else {
				e.currentTarget.setAttribute('aria-expanded', 'false');

				slideUp({
					element: buttons,
					slideSpeed: 400,
					easing: 'ease-in-out',
				});

				allLinks.forEach((otherLink) => {
					otherLink.setAttribute('tabindex', '-1');
				});
			}
		});
	});

	const checkFooterAccordionItems = () => {
		if (previousWidth && previousWidth >= 768 && window.innerWidth >= 768) {
			return;
		} else if (
			previousWidth &&
			previousWidth < 768 &&
			window.innerWidth < 768
		) {
			return;
		}

		if (window.innerWidth >= 768) {
			footerAccordionLinks.forEach((link) => {
				link.setAttribute('aria-expanded', 'true');
				link.setAttribute('tabindex', '-1');
			});

			footerAccordionContents.forEach((content) => {
				content.classList.remove('DOM-slider-hidden');
				content.setAttribute('aria-hidden', 'false');
			});
		} else {
			footerAccordionLinks.forEach((link) => {
				link.setAttribute('aria-expanded', 'false');
				link.setAttribute('tabindex', '0');
			});

			footerAccordionContents.forEach((content) => {
				content.classList.add('DOM-slider-hidden');
				content.setAttribute('aria-hidden', 'true');

				const allLinks = content.querySelectorAll(
					'.wp-block-button__link'
				);

				allLinks.forEach((otherLink) => {
					otherLink.setAttribute('tabindex', '-1');
				});
			});
		}

		previousWidth = window.innerWidth;
	};

	footerAccordionContents.forEach((content) => {
		content.classList.add('block-content--initialized');
	});

	checkFooterAccordionItems();

	window.addEventListener('resize', throttle(checkFooterAccordionItems, 100));
}
